import React from 'react'
const Devider = () => {
    return (
        <div style={{height: '70px'}}></div>
    )
}

export default Devider
